export default __webpack_public_path__ + "locales/el-GR/EmptyTrashDialog.json?hash=df88bcb651b1439cbbd5037baa9513c8";